import request from '@/utils/request'

const basePath = '/api/arrangement'

/**
 * 获取用户考试试卷
 * @returns {*}
 */
export function getUserExamPaper() {
    return request({
        url: `${basePath}/user/paper`,
        method: 'GET'
    })
}

export function getExamCurrent() {
    return request({
        url: `/api/arrangement/examinee/current`,
    })
}

/**
 * 获取试卷
 * @param examPaperId
 * @returns {AxiosPromise}
 */
export function getExamPaper(examPaperId) {
    return request({
        url: `${basePath}/test_paper/${examPaperId}/exam`,
        method: 'GET'
    })
}

/**
 * 获取试卷标准答案（管理员）
 * @param examPaperId
 */
export function getExamPaperAnswerByAdmin(examPaperId) {
    return request({
        url: `/api/review/test_paper/${examPaperId}/question/answer/admin`,
        method: 'GET'
    })
}

/**
 * 获取试卷标准答案（学生）
 * @param examPaperId
 */
export function getExamPaperAnswer(examPaperId) {
    return request({
        url: `/api/review/test_paper/${examPaperId}/question/answer`,
        method: 'GET'
    })
}

/**
 * 保存竞赛计划
 * @param data
 * @returns {AxiosPromise}
 */
export function addExam(data) {
    return request({
        url: `${basePath}`,
        method: 'post',
        data: data
    })
}

/**
 * 编辑竞赛计划
 * @param data
 * @returns {AxiosPromise}
 */
export function updateExam(id, data) {
    return request({
        url: `${basePath}/com.tipdm:tipdm-race-web:jar:v1.10.0`,
        method: 'put',
        data: data
    })
}

/**
 * 更新竞赛计划高级设置
 * @param id 计划ID
 * @param data 高级设置参数
 * @returns {AxiosPromise}
 */
export function updateExamAdvanced(id, data) {
    return request({
        url: `${basePath}/com.tipdm:tipdm-race-web:jar:v1.10.0/advanced`,
        method: 'put',
        data: data
    })
}

/**
 * 获取竞赛计划
 * @param data
 * @returns {AxiosPromise}
 */
export function getExam(id) {
    return request({
        url: `${basePath}/com.tipdm:tipdm-race-web:jar:v1.10.0`,
        method: 'get'
    })
}

/**
 * 获取竞赛计划
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteExam(ids) {
    return request({
        url: `${basePath}`,
        method: 'delete',
        params: {ids: ids}
    })
}

/**
 * 根据竞赛计划id获取竞赛赛卷列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getExamPapers(id) {
    return request({
        url: `${basePath}/exam/paper/com.tipdm:tipdm-race-web:jar:v1.10.0`,
        method: 'get'
    })
}

/**
 * 根据竞赛计划id获取竞赛赛卷限制数量
 * @param data
 * @returns {AxiosPromise}
 */
export function getExamPaperLimitNum() {
    return request({
        url: `${basePath}/exam/paper/number`,
        method: 'get'
    })
}

/**
 * 新增选手
 * @param data
 * @returns {AxiosPromise}
 */
export function addExaminee(examId, data) {
    return request({
        url: `${basePath}/examinee/${examId}`,
        method: 'post',
        data: data
    })
}

/**
 * 编辑选手
 * @param examId
 * @param examineeId
 * @param data
 * @returns {AxiosPromise}
 */
export function editExaminee(examId, examineeId, data) {
    return request({
        url: `${basePath}/examinee/${examId}/${examineeId}`,
        method: 'put',
        data: data
    })
}

/**
 * update answer
 */
export function validExamStartTime(params) {
    return request({
        url: `${basePath}/exam/valid/startTime`,
        method: 'GET',
        params: params
    })
}


